<template>
  <v-card class="ma-4">
    <v-card-title style="text-align: left">Informações básicas</v-card-title>
    <v-card-text>
      <v-row class="pa-3">
        <v-col cols="12" sm="6" lg="6" xl="4" class="col-bordered">
          <span class="key-title">Fazenda: </span>
          <span class="value-title">{{
            relatorio.fazenda.pessoajuridica.NomeFantasia
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="6" xl="4" class="col-bordered">
          <span class="key-title">Produtor(a): </span>
          <span class="value-title">{{ relatorio.fazenda.produtor.Nome }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="6" xl="6" class="col-bordered">
          <span class="key-title">Matrícula: </span>
          <span class="value-title">{{
            relatorio.fazenda.Matricula ||
            relatorio.fazenda.produtor.Matricula ||
            '-'
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="6" xl="6" class="col-bordered">
          <span class="key-title">Consultor(a): </span>
          <span class="value-title">{{
            relatorio.consultor.pessoafisica.Nome
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="4" xl="4" class="col-bordered">
          <span class="key-title">Cidade: </span>
          <span
            v-if="relatorio.cidadefazenda && relatorio.cidadefazenda.Nome"
            class="value-title"
          >
            {{ relatorio.cidadefazenda.Nome }}
          </span>
          <span v-else class="value-title">
            <span v-if="relatorio.fazenda.pessoa.endereco" class="value-title">
              {{ relatorio?.fazenda?.pessoa?.endereco?.cidade?.Nome || '-' }}
            </span>
            <span v-else class="value-title">
              {{ 'Não informado.' }}
            </span>
          </span>
        </v-col>
        <v-col cols="12" sm="6" lg="4" xl="4" class="col-bordered">
          <span class="key-title">Data: </span>
          <span v-if="relatorio.DataAtendimento" class="value-title">{{
            relatorio.DataAtendimento
          }}</span>
          <span v-else class="value-title">{{
            moment(relatorio.DataInicio).format('DD/MM/YYYY')
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="4" xl="4" class="col-bordered">
          <span class="key-title">Horário do ínicio: </span>
          <span v-if="relatorio.HoraInicio" class="value-title">{{
            relatorio.HoraInicio
          }}</span>
          <span v-else class="value-title">{{
            moment(relatorio.DataInicio).format('HH:mm')
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="4" xl="4" class="col-bordered">
          <span class="key-title">Horário do término: </span>
          <span v-if="relatorio.HoraFim" class="value-title">{{
            relatorio.HoraFim
          }}</span>
          <span v-else class="value-title">{{
            moment(relatorio.DataFim).format('HH:mm')
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="4" xl="4" class="col-bordered">
          <span class="key-title">Número da visita: </span>
          <span class="value-title">{{ relatorio.NumeroVisita }}ª visita</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'InformacoesGerais',
  props: {
    relatorio: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
}
</script>

<style scoped>
.key-title {
  font-weight: 500;
  font-size: '16px';
}

.value-title {
  font-size: '16px';
}

.col-bordered {
  border: solid 1px #ccc;
}
</style>
